import { ref, watch, computed } from '@vue/composition-api'
import popups from '@/hooks/popups';
import i18n from "@/libs/i18n";
import store from "@/store";

export default function discountListQuery() {
    const { errorToast } = popups()
    const perPageOptions = [10, 25, 50, 100]
    const isSortDirDesc = ref(true)
    const groupFilter = ref(null)
    const groupOptions = ref([])
    const searchQuery = ref('')
    const discountTable = ref(null)
    const currentPage = ref(1)
    const sortBy = ref('id')
    const totalDiscount = ref(0)
    const perPage = ref(10)
    const tableColumns = [
        { key: 'name', label: i18n.t('Name'), sortable: true },
        { key: 'value', label: i18n.t('Value'), sortable: true },
        { key: 'item_type', label: 'Aplicable a ' },
        { key: 'item', label: 'Asociado' },
        { key: 'status', label: i18n.t('Status'), sortable: true },
        { key: 'actions', label: i18n.t('Actions') }
    ]

    const dataMeta = computed(() => {
        const localItemsCount = discountTable.value ? discountTable.value.localItems.length: 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalDiscount.value,
        }
    });

    const refetchData = function() {
        discountTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery, groupFilter], () => {
        refetchData()
    })

    const fetchDiscount = function(ctx, callback) {
        store.dispatch('discounts/fetchDiscounts', {
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
            group: groupFilter.value,
        })
        .then(response => {
            const { discounts, total } = response.data
            callback(discounts)
            totalDiscount.value = total
        })
        .catch(() => { errorToast("Error fetching discount list") })
    }

    return {
        fetchDiscount,
        tableColumns,
        perPage,
        currentPage,
        totalDiscount,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        discountTable,
        refetchData,
        groupFilter,
        groupOptions
    }
}
